import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.svg"
import feature3 from "./feature-3.svg"
import feature4 from "./feature-4.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const PriceX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title: "Pricing intelligence & \nmanagement builds \nshopper loyalty",
    bannerImage: banner,
    desc:
      "The only competitor price monitoring software you would need to \nknow the pulse of the market in real-time. Don’t let competitor price \nupdates lead to revenue loss. Get to know the relevant prices listed \non competitor sites and get these automatically updated on your site \ntoo.",
    overview: "PriceX Overview",
    overviewText:
      "Finding out the pricing policies and offers provided by your competitor is no longer a challenge. The PriceX traverses your competitor sites and brings to you the latest prices associated with a product. This way you don’t lose on customers because of lowered prices advertised by your competitors. If there is a price update, it will be applied to your site too in quick time. No need to keep a team to monitor prices for thousands of products and then move in to make changes as and when it happens.",
    features: [
      {
        title: "The power of knowledge with \nprice scraping",
        description:
          "You get to know in real-time, the price updates made to a product across the \nmarketplaces. Monitor your competitor’s products price in any country, \ncurrency or marketplace (e.g. Amazon and eBay), on a daily basis.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Ai meant to deliver\n business excellence",
        description:
          "With our Wersel Price Intelligence you can monitor an eCommerce \ncompetitor directly, price comparison websites like Google Shopping, Ideal, \nor even individual merchants in a marketplace like Amazon or eBay.",
        featureImage: feature2,
        imagePosition: "left",
      },
      {
        title: "Minimum Advertised Price \n(MAP) Monitoring",
        description:
          "Set the rules for minimum price allowed and let us handle the tracking. \nFollow resellers to ensure zero negative impact on brand’s price positioning \n& image that can be brought about by sellers selling below the minimum \nprices.",
        featureImage: feature3,
        imagePosition: "right",
      },
      {
        title: "Dynamic pricing \nupdates",
        description:
          "PriceX sets prices automatically to improve profit margins whenever market prices offered \nby competitors, or stock availabilities change. Our software helps you build customer \nloyalty by enforcing your price matching policies which will be at par with competitors.",
        featureImage: feature4,
        imagePosition: "left",
      },
    ],
    subSectionTitle: "Explore PriceX",
    platformText:
      "PriceX utilizes powerful MAP monitoring to get real-time pricing updates to particular products. If there are changes, then the same will be applied immediately to your ecommerce site as well. As a result, when shoppers come to your site, they always see the most recently updated price that is applicable to other marketplaces and sellers too. Shape your price strategy with in-depth knowledge of the right pricing applicable across the eCommerce landscape.",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "pricex",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#2FB2C7" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel PriceX - Result-oriented pricing intelligence tool now available "
        keywords="pricing intelligence platform, pricing intelligence software, ecommerce pricing intelligence, ecommerce pricing monitoring tool."
        description="The only price intelligence software you would need to know the pulse of the market in real-time. Don’t let competitor price updates lead to revenue loss. Get to know the relevant prices listed on competitor sites and get these automatically updated on your site too."
        url="www.wersel.io/products/pricex"
      />
      <OurSolutions data={data} btnBg="#2FB2C7" btnColor="#FFFFFF" />
      <Features title="PriceX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="Result-oriented pricing intelligence tool now available"
        howItWorks="Get a competitive advantage with the AI-based online price monitoring, price \ncomparison, and repricing tool"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#2FB2C7"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default PriceX
